import React, {ReactElement} from 'react';

export const NewTabLink = ({
  children,
  ...props
}: React.LinkHTMLAttributes<HTMLAnchorElement>): ReactElement => (
  <a {...props} rel='noopener noreferrer' target='_blank'>
    {children}
  </a>
);
